import { Component, OnInit } from '@angular/core';
import { IntegradorService } from '../../../../services/integrador.service';
import { ToastService } from '../../../../services/toast.service';
import { GrupoMaterial } from '../../../../types/GrupoMaterial.type';

@Component({
  selector: 'app-gruposmateriais',
  templateUrl: './gruposmateriais.component.html',
  styleUrl: './gruposmateriais.component.css'
})
export class GruposmateriaisComponent implements OnInit {

  grupos: GrupoMaterial[] = [];
  loading: boolean = false;

  constructor(private integradorService: IntegradorService, private toastService: ToastService){}

  ngOnInit(){

    this.carregarGrupos()
  }

  carregarGrupos(){
    this.loading = true;

    this.integradorService.getGruposMateriais().subscribe({
      next: (data) => {
        this.grupos = data;
      },
      error: (error) => {
        this.toastService.erro("Erro", "Erro ao buscar as informações: " + error.error.message);
      },
      complete: () => {
        this.loading = false;
      }
    })
  }

}
